import React from 'react'

export const Register = () => {
  return (
    <div>Register</div>
  )
}
